// source: uaot/api/v1/responses.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var uaot_api_v1_event_pb = require('../../../uaot/api/v1/event_pb.js');
goog.object.extend(proto, uaot_api_v1_event_pb);
goog.exportSymbol('proto.uaot.api.v1.GetEventResponse', null, global);
goog.exportSymbol('proto.uaot.api.v1.ListEventResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.uaot.api.v1.GetEventResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.uaot.api.v1.GetEventResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.uaot.api.v1.GetEventResponse.displayName = 'proto.uaot.api.v1.GetEventResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.uaot.api.v1.ListEventResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.uaot.api.v1.ListEventResponse.repeatedFields_, null);
};
goog.inherits(proto.uaot.api.v1.ListEventResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.uaot.api.v1.ListEventResponse.displayName = 'proto.uaot.api.v1.ListEventResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.uaot.api.v1.GetEventResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.uaot.api.v1.GetEventResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.uaot.api.v1.GetEventResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.uaot.api.v1.GetEventResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    event: (f = msg.getEvent()) && uaot_api_v1_event_pb.Event.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.uaot.api.v1.GetEventResponse}
 */
proto.uaot.api.v1.GetEventResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.uaot.api.v1.GetEventResponse;
  return proto.uaot.api.v1.GetEventResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.uaot.api.v1.GetEventResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.uaot.api.v1.GetEventResponse}
 */
proto.uaot.api.v1.GetEventResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new uaot_api_v1_event_pb.Event;
      reader.readMessage(value,uaot_api_v1_event_pb.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.uaot.api.v1.GetEventResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.uaot.api.v1.GetEventResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.uaot.api.v1.GetEventResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.uaot.api.v1.GetEventResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      uaot_api_v1_event_pb.Event.serializeBinaryToWriter
    );
  }
};


/**
 * optional Event event = 1;
 * @return {?proto.uaot.api.v1.Event}
 */
proto.uaot.api.v1.GetEventResponse.prototype.getEvent = function() {
  return /** @type{?proto.uaot.api.v1.Event} */ (
    jspb.Message.getWrapperField(this, uaot_api_v1_event_pb.Event, 1));
};


/**
 * @param {?proto.uaot.api.v1.Event|undefined} value
 * @return {!proto.uaot.api.v1.GetEventResponse} returns this
*/
proto.uaot.api.v1.GetEventResponse.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.uaot.api.v1.GetEventResponse} returns this
 */
proto.uaot.api.v1.GetEventResponse.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.uaot.api.v1.GetEventResponse.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.uaot.api.v1.ListEventResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.uaot.api.v1.ListEventResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.uaot.api.v1.ListEventResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.uaot.api.v1.ListEventResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.uaot.api.v1.ListEventResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventList: jspb.Message.toObjectList(msg.getEventList(),
    uaot_api_v1_event_pb.Event.toObject, includeInstance),
    pages: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.uaot.api.v1.ListEventResponse}
 */
proto.uaot.api.v1.ListEventResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.uaot.api.v1.ListEventResponse;
  return proto.uaot.api.v1.ListEventResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.uaot.api.v1.ListEventResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.uaot.api.v1.ListEventResponse}
 */
proto.uaot.api.v1.ListEventResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new uaot_api_v1_event_pb.Event;
      reader.readMessage(value,uaot_api_v1_event_pb.Event.deserializeBinaryFromReader);
      msg.addEvent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.uaot.api.v1.ListEventResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.uaot.api.v1.ListEventResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.uaot.api.v1.ListEventResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.uaot.api.v1.ListEventResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      uaot_api_v1_event_pb.Event.serializeBinaryToWriter
    );
  }
  f = message.getPages();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated Event event = 1;
 * @return {!Array<!proto.uaot.api.v1.Event>}
 */
proto.uaot.api.v1.ListEventResponse.prototype.getEventList = function() {
  return /** @type{!Array<!proto.uaot.api.v1.Event>} */ (
    jspb.Message.getRepeatedWrapperField(this, uaot_api_v1_event_pb.Event, 1));
};


/**
 * @param {!Array<!proto.uaot.api.v1.Event>} value
 * @return {!proto.uaot.api.v1.ListEventResponse} returns this
*/
proto.uaot.api.v1.ListEventResponse.prototype.setEventList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.uaot.api.v1.Event=} opt_value
 * @param {number=} opt_index
 * @return {!proto.uaot.api.v1.Event}
 */
proto.uaot.api.v1.ListEventResponse.prototype.addEvent = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.uaot.api.v1.Event, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.uaot.api.v1.ListEventResponse} returns this
 */
proto.uaot.api.v1.ListEventResponse.prototype.clearEventList = function() {
  return this.setEventList([]);
};


/**
 * optional int32 pages = 2;
 * @return {number}
 */
proto.uaot.api.v1.ListEventResponse.prototype.getPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.uaot.api.v1.ListEventResponse} returns this
 */
proto.uaot.api.v1.ListEventResponse.prototype.setPages = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.uaot.api.v1);
